import { render, staticRenderFns } from "./UpgradeNudge.vue?vue&type=template&id=5ab8f0be&scoped=true&"
import script from "./UpgradeNudge.vue?vue&type=script&lang=js&"
export * from "./UpgradeNudge.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeNudge.vue?vue&type=style&index=0&id=5ab8f0be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8f0be",
  null
  
)

export default component.exports